module.exports = __webpack_public_path__ + "img/1762097278631-zg0JHk7h.f0003ac9.png";